import React from 'react';
import { BRAND_NAME } from '../constants/brand';

/** Icono simplificado al estilo app oficial de WhatsApp (burbuja + teléfono) */
const WhatsAppAppIcon = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38c1.45.79 3.08 1.21 4.79 1.21 5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.816 9.816 0 0 0 12.04 2zm0 17.82c-1.6 0-3.17-.43-4.54-1.24l-.33-.19-3.03.8.8-2.95-.2-.33a8.14 8.14 0 0 1-1.23-4.36c0-4.5 3.66-8.16 8.17-8.16 2.18 0 4.23.85 5.76 2.39a8.1 8.1 0 0 1 2.38 5.77c0 4.5-3.66 8.16-8.18 8.16z" />
    <path d="M16.57 14.24c-.25-.12-1.47-.73-1.7-.81-.23-.08-.4-.12-.57.12-.17.25-.66.81-.81.97-.15.17-.3.19-.55.06-.25-.12-1.05-.39-2-1.23-.74-.66-1.23-1.48-1.38-1.73-.14-.25 0-.38.11-.51.11-.11.25-.3.38-.45.12-.15.17-.25.25-.42.08-.17.04-.32-.02-.45-.06-.12-.57-1.37-.78-1.88-.2-.5-.41-.42-.57-.43-.15-.01-.32-.01-.49-.01-.17 0-.43.08-.66.38-.23.25-.88.86-.88 2.1 0 1.24.9 2.43 1.03 2.6.12.17 1.75 2.67 4.23 3.74.59.26 1.05.42 1.41.54.6.19 1.15.16 1.58.1.5-.08 1.54-.63 1.76-1.24.22-.61.22-1.13.15-1.24-.06-.11-.22-.18-.47-.3z" />
  </svg>
);

const WhatsAppButton = () => {
  const handleClick = () => {
    const phone = '51947726382';
    const message = `Hola. Me interesa conocer más sobre los servicios de software de ${BRAND_NAME}.

¿Podrían contactarme para brindarme información detallada?

Gracias.`;

    window.open(`https://wa.me/${phone}?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="whatsapp-button"
      aria-label="Contactar por WhatsApp"
    >
      <WhatsAppAppIcon className="h-8 w-8 sm:h-9 sm:w-9" />
    </button>
  );
};

export default WhatsAppButton;
